@import '../../../global/component.css';

.hero-background::after {
  background-image: url(/assets/conductor-cat.webp);
  background-position: center 25%;
}